import React, {useState, useEffect} from "react";
import {ConfigProvider, Modal} from "antd";
import "./BottomBanner.scss";
import {useNavigate} from "react-router-dom";

const BottomBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    // Set initial mobile state
    const mobileView = window.innerWidth < 768;
    setIsMobile(mobileView);

    // Check if banner was dismissed in this session
    const isDismissed = localStorage.getItem("bannerDismissed") === "true";

    // Show banner/modal if not dismissed
    if (!isDismissed) {
      setIsVisible(!mobileView);
      setIsModalOpen(mobileView);
    }

    // Handle window resize
    const handleResize = () => {
      const newMobileView = window.innerWidth < 768;
      setIsMobile(newMobileView);

      // Only show banner if not dismissed
      if (!localStorage.getItem("bannerDismissed") === "true") {
        setIsVisible(!newMobileView);
        setIsModalOpen(newMobileView);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array since we want this to run only on mount

  const handleClose = () => {
    localStorage.setItem("bannerDismissed", "true"); // Persist until cleared
    setIsVisible(false);
    setIsModalOpen(false);
  };

  // Reset dismissed state on refresh by listening to beforeunload
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("bannerDismissed");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const handleNavigationLinks = (url) => {
    window.open(url, "_blank");
  };

  return (
    <>
      {/* Desktop Banner */}
      {isVisible && !isMobile && (
        <div className="bottomBannerContainer">
          <p>
            Please note that all accounts we provide to our clients are demo accounts with simulated funds and any trading is conducted in a simulated environment. References to trading, traders,
            revenue, and profit are references to virtual trading, revenues, and profits respectively. More details can be found in the
            <span onClick={() => handleNavigationLinks("https://help.alphacapitalgroup.uk/en")}>FAQ</span> section.
            <span
              className="closeText"
              onClick={handleClose}
            >
              Okay I Understand.
            </span>
          </p>
        </div>
      )}

      {/* Mobile Modal */}
      {isMobile && isModalOpen && (
        <ConfigProvider
          theme={{
            components: {
              Modal: {
                contentBg: "#000",
                colorText: "#fff",
              },
            },
          }}
        >
          <Modal
            open={isModalOpen}
            onCancel={handleClose}
            footer={null}
            centered
            // closeIcon={
            //   <button
            //     className="closeBtnMobile"
            //     onClick={handleClose}
            //   >
            //     ✖
            //   </button>
            // }
          >
            <div className="modalContent">
              <p>
                Please note that all accounts we provide to our clients are demo accounts with simulated funds and any trading is conducted in a simulated environment. More details can be found in the
                <span onClick={() => handleNavigationLinks("https://help.alphacapitalgroup.uk/en")}>FAQ</span> section.
              </p>
              <button
                className="gradientButton_small understandBtn"
                onClick={handleClose}
              >
                Okay I Understand.
              </button>
            </div>
          </Modal>
        </ConfigProvider>
      )}
    </>
  );
};

export default BottomBanner;
